import React from "react";
import {
  Card,
  CardHeader,
  Typography,
  Grid,
  Divider,
  Stack,
} from "@mui/material";

const BasicInfo = ({ product }) => {
  return (
    <Card elevation={4} sx={{ padding: 3, maxWidth: 900 }}>
      <CardHeader
        title={
          <Typography
            variant="h5"
            fontWeight="bold"
            align="center"
            sx={{ mb: 2 }}
          >
            Basic Information
          </Typography>
        }
      />
      <Divider sx={{ mb: 2 }} />
      <Grid container spacing={2}>
        {Object.entries(product).map(([key, value]) => (
          <Grid item xs={12} sm={6} key={key}>
            <Stack direction="row" justifyContent="space-between" spacing={2}>
              <Typography
                variant="subtitle2"
                color="textPrimary"
                sx={{ fontWeight: 600, textTransform: "capitalize", flex: 1 }}
              >
                {key.replace(/([A-Z])/g, " $1")}:
              </Typography>
              {key.includes("image") && value ? (
                <img
                  src={`https://cms-test.my-ogawa.com/backend/uploads/bodyfriend/productGif/${value}`}
                  alt={value}
                  style={{
                    maxWidth: "100px",
                    maxHeight: "100px",
                    borderRadius: "8px",
                  }}
                />
              ) : (
                <Typography
                  variant="body2"
                  color="textSecondary"
                  sx={{ flex: 2 }}
                >
                  {value || "N/A"}
                </Typography>
              )}
            </Stack>
          </Grid>
        ))}
      </Grid>
    </Card>
  );
};

export default BasicInfo;
